import { useEffect, useState } from "react";
import { useTheme } from "../../../../components/hooks/useTheme";
import colorConfigs from "../../../../configs/colorConfigs";
import { RepairOrderList } from "./RepairOrderList";
import { AddRepairOrder } from "./AddRepairOrder";

const filterItems = [
    {
        id: 0,
        label: "Maintenance Type",
    },
]

type RepairOrderProps = {
    idNumber: any;
}

export const RepairOrder = ({
    idNumber
}: RepairOrderProps) => {
    const { themeStyles } = useTheme();
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    });
    const [searchValue, setSearchValue] = useState<string>("");
    const [repairOrderFilterValue, setRepairOrderFilterValue] = useState(0);
    const [selectedFilter, setSelectedFilter] = useState<string>(filterItems[0].label);
    const [openAddRepairOrder, setOpenAddRepairOrder] = useState<boolean>(false);
    const [refreshRepairOrderList, setRefreshRepairOrderList] = useState<boolean>(false);

    useEffect(() => {
        if (refreshRepairOrderList) {
            setPaginationModel({
                page: 0,
                pageSize: 10,
            })
            setSearchValue("");
            setRefreshRepairOrderList(false);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refreshRepairOrderList])

    return (
        <>
            <div className={`px-[24px] py-[20px] min-h-screen h-full`}>

                <div className="flex items-center justify-end">
                    <div className="flex items-center gap-2.5">
                        <button className={`px-[8px] py-[6px] ${colorConfigs.btn.main.tailwind} rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
                            onClick={() => setOpenAddRepairOrder(true)}
                        >
                            <span className="material-symbols-outlined text-[25px] font-light">
                                add
                            </span>
                            <span className="text-xs font-medium">Repair Order</span>
                        </button>
                    </div>
                </div>
                <div>
                    <RepairOrderList
                        paginationModel={paginationModel}
                        setPaginationModel={setPaginationModel}
                        searchValue={searchValue}
                        setSearchValue={setSearchValue}
                        repairOrderFilterValue={repairOrderFilterValue}
                        setRepairOrderFilterValue={setRepairOrderFilterValue}
                        selectedFilter={selectedFilter}
                        setSelectedFilter={setSelectedFilter}
                        filterItems={filterItems}
                        idNumber={idNumber}
                        setRefreshRepairOrderList={setRefreshRepairOrderList}
                    />
                </div>
            </div>
            {
                openAddRepairOrder && (
                    <AddRepairOrder
                        idNumber={idNumber}
                        openAddRepairOrder={openAddRepairOrder}
                        setOpenAddRepairOrder={setOpenAddRepairOrder}
                        setRefreshRepairOrderList={setRefreshRepairOrderList}
                    />
                )
            }
        </>
    )
}